import { FC } from 'react';
import style from './index.module.css';
import { PrefixBadge } from '../../common/PrefixBadge';

export const PaymentMethodDetail: FC<{ 
  prefix: string,
  value: string,
}> = ({ prefix, value }) => {

  return (
    <div className={style.informationDetail}>
      <PrefixBadge>{prefix}</PrefixBadge>
      <div className={style.informationDetail_content}>
        {value}
      </div>
    </div>
  );
}